import { useState, useContext } from "react";
import { supabase } from "../supabase";
import { CartContext, AuthContext, CartUIContext, AdminContext, BrandContext } from "../contexts";
import { Btn, NavBtn } from "./ui";

const Nav = ({ view, setView, setInitialAccountTab }) => {
  const { cart } = useContext(CartContext);
  const { user, setUser } = useContext(AuthContext);
  const { setCartOpen } = useContext(CartUIContext);
  const { maintenanceMode } = useContext(AdminContext);
  const b = useContext(BrandContext);
  const total = cart.reduce((s, i) => s + i.qty, 0);
  const [menuOpen, setMenuOpen] = useState(false);

  const navTo = (v, opts) => { setMenuOpen(false); if (opts) Object.entries(opts).forEach(([k, fn]) => fn()); setView(v); };

  return (
    <nav style={{ background: "var(--surface)", borderBottom: "1px solid var(--border)", position: "sticky", top: 0, zIndex: 100, boxShadow: "0 1px 12px rgba(0,0,0,0.2)" }}>
      {maintenanceMode && (user?.isAdmin || user?.role === "manager") && (
        <div style={{ background: "var(--amber)", padding: "6px 24px", textAlign: "center" }}>
          <span style={{ fontFamily: "var(--font-mono)", fontSize: "11px", fontWeight: 700, color: "#111", letterSpacing: "0.1em" }}>
            ⚠ MAINTENANCE MODE ACTIVE
          </span>
        </div>
      )}
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between", position: "relative" }}>
        <button onClick={() => navTo("landing")} style={{ fontFamily: "var(--font-display)", fontSize: "22px", color: "var(--text)", letterSpacing: "-0.02em", display: "flex", alignItems: "center" }}>
          {b.logoUrl
            ? <img src={b.logoUrl} alt={b.name} style={{ height: 32, display: "block" }} />
            : <>{b.name} <span style={{ color: "var(--amber)" }}>{b.nameAccent}</span></>
          }
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Hamburger button — mobile only */}
          <button className="mobile-menu-btn" onClick={() => setMenuOpen(m => !m)}
            style={{ display: "flex", flexDirection: "column", gap: 4, padding: 8, alignItems: "center", justifyContent: "center" }}>
            <span style={{ width: 20, height: 2, background: "var(--text)", borderRadius: 1, transition: "all 0.2s", transform: menuOpen ? "rotate(45deg) translateY(6px)" : "none" }} />
            <span style={{ width: 20, height: 2, background: "var(--text)", borderRadius: 1, transition: "all 0.2s", opacity: menuOpen ? 0 : 1 }} />
            <span style={{ width: 20, height: 2, background: "var(--text)", borderRadius: 1, transition: "all 0.2s", transform: menuOpen ? "rotate(-45deg) translateY(-6px)" : "none" }} />
          </button>

          {/* Nav links — desktop inline, mobile dropdown */}
          <div className={`nav-links${menuOpen ? " open" : ""}`} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {user ? (
              <>
                <NavBtn isActive={view === "shop" || view === "product"} onClick={() => navTo("shop")}>Shop</NavBtn>
                <NavBtn isActive={view === "updates"} onClick={() => navTo("updates")}>Updates</NavBtn>
                <NavBtn isActive={view === "account"} onClick={() => { setMenuOpen(false); sessionStorage.setItem("accountTab", "profile"); if (setInitialAccountTab) setInitialAccountTab("profile"); setView("account"); }}>My Account</NavBtn>
                <NavBtn isActive={view === "calculator"} onClick={() => navTo("calculator")}>Calculator</NavBtn>
                <NavBtn isActive={view === "contact"} onClick={() => navTo("contact")}>Contact</NavBtn>
                {(user.isAdmin || user.role === "manager") && <NavBtn isActive={view === "admin"} onClick={() => navTo("admin")}>Admin</NavBtn>}
                <NavBtn isActive={false} onClick={() => { setMenuOpen(false); supabase.auth.signOut(); setUser(null); setView("landing"); }}>Sign Out</NavBtn>
              </>
            ) : (
              <>
                <NavBtn isActive={view === "contact"} onClick={() => navTo("contact")}>Contact</NavBtn>
                <Btn small onClick={() => navTo("auth")}>Sign In</Btn>
              </>
            )}
          </div>

          {user && (
            <button onClick={() => setCartOpen(true)} style={{ position: "relative", color: "var(--text)", display: "flex", alignItems: "center", gap: "6px", padding: "8px 14px", border: "2px solid var(--border)", borderRadius: "var(--radius)", transition: "border-color 0.15s" }}
              onMouseEnter={e => e.currentTarget.style.borderColor = "var(--amber)"}
              onMouseLeave={e => e.currentTarget.style.borderColor = "var(--border)"}>
              <span>🛒</span>
              <span style={{ fontFamily: "var(--font-mono)", fontSize: "13px" }}>{total}</span>
              {total > 0 && <span style={{ position: "absolute", top: -6, right: -6, width: 14, height: 14, borderRadius: "50%", background: "var(--amber)", fontSize: 9, display: "flex", alignItems: "center", justifyContent: "center", color: "#111", fontWeight: 700 }}>{total}</span>}
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Nav;
